export const setListaPartesAction = listaPartes => ({
  type: 'SET_LISTA_PARTES_SUCESS',
  listaPartes
});
